import Vue from 'vue'

export default {
  login (form, config = {}) {
    return Vue.http.post(`/login`, form)
  },

  logout () {
    return Vue.http.post('/logout', {})
  }
}



// WEBPACK FOOTER //
// ./src/services/main.js